import { useDispatch } from 'react-redux'

// Actions
import { actions as browseActions } from 'modules/browse/actions'

// Components
import { Select, IconViewModeDefault, IconViewModeCompact } from '@tracklib/kit'

// Hooks
import { useDisplayMode } from 'modules/browse/hooks'

// Utils
import { safeLocalStorage as localStorage } from 'utils'

import styles from './displaymode.css'

const options = [
  { label: 'Full', icon: <IconViewModeDefault />, id: 'full' },
  { label: 'Compact', icon: <IconViewModeCompact />, id: 'compact' },
]

const DisplayMode = (): JSX.Element => {
  const dispatch = useDispatch()
  const displayMode = useDisplayMode()
  const localStorageDisplayMode = localStorage.getItem('displayMode')
  const localStorageDisplayModeRelevant = options.some(({ id }) => id === localStorageDisplayMode)
  return (
    <Select
      name="display_mode"
      value={localStorageDisplayModeRelevant ? localStorageDisplayMode : displayMode}
      onChange={(value: string) => dispatch(browseActions.setDisplayMode(value))}
      className={styles.select}
      custom
    >
      {options.map(({ id, icon, label }) => (
        <div key={String(id)} value={id} className={styles.item}>
          <span className={styles.icon}>{icon}</span>
          <span className={styles.label}>{label}</span>
        </div>
      ))}
    </Select>
  )
}

export default DisplayMode
